// src/CameraClassicIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CameraClassicIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "103",
    height: "72",
    viewBox: "0 0 103 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#camera-classic-clip)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "m8.9 11.4-2.7.4c-4.2.3-6 2.8-5.6 7.4l1.9 13.9 21.3-3c.7-2.2 1.8-4.4 3.4-6.5 3.5-4.6 8.2-7.4 14-8.2 5.8-.8 11 .5 15.7 4 1.9 1.4 3.4 3 4.7 4.8l34-4.7-2-14.1C92.7 1.7 90.5 0 87 .5L19.8 9.9 9 11.4"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "m7.5 19.7-.7-4.9 10.8-1.5.7 4.9-10.8 1.5ZM85.82 7.346 69.873 9.559l1.1 7.924L86.92 15.27l-1.1-7.924ZM99.4 48.998l-27.6 3.9-18.7 2.6c-1.9.9-4 1.5-6.3 1.8-2.3.3-4.5.3-6.6 0l-10.4 1.4-23.2 3.3c.8 4.6 3.3 6.4 7.4 5.6l18.3-2.6 41.8-5.9 20.4-2.9c3.5-.6 5.1-2.8 5-6.6v-.7l-.1.1Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#6C5438",
            d: "M25.8 47.203c-1.4-2.3-2.3-4.9-2.7-7.8-.5-3.3-.2-6.3.7-9.2l-21.3 3 4 28.9 23.4-3.3 10.4-1.4c-3.2-.6-6.2-1.9-9-4-2.3-1.8-4.2-3.8-5.6-6.1l.1-.1ZM95.5 19.602l-34 4.7c1.9 2.7 3 5.7 3.5 9.2v.3c.7 5.6-.6 10.8-4.1 15.4-2.1 2.8-4.7 4.9-7.6 6.3l18.7-2.6 27.6-3.9-4.1-29.4Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#838383",
            d: "M41.2 15.501c-5.8.8-10.5 3.5-14 8.2-1.6 2.1-2.7 4.2-3.4 6.5-.9 2.9-1.2 5.9-.7 9.2.4 2.9 1.3 5.5 2.7 7.8 1.4 2.3 3.2 4.3 5.6 6.1 2.8 2.1 5.8 3.4 9 4 2.1.3 4.4.4 6.6 0 2.3-.3 4.4-.9 6.3-1.8 3-1.4 5.5-3.5 7.6-6.3 3.4-4.6 4.8-9.7 4.1-15.4v-.3c-.5-3.4-1.7-6.5-3.5-9.2-1.3-1.8-2.8-3.4-4.7-4.8-4.7-3.5-9.9-4.8-15.7-4"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#838383",
            d: "M29.9 25.602c3-4 6.9-6.3 11.7-6.9 4.9-.7 9.3.5 13.2 3.5 4 3 6.3 6.9 6.9 11.7.7 4.9-.5 9.3-3.5 13.2-3 3.9-6.9 6.2-11.8 6.9-4.9.7-9.2-.5-13.2-3.4-3.9-3-6.2-6.9-6.9-11.8-.7-4.9.5-9.2 3.4-13.2M55.6 21l-.2-.2.2-.5c.1 0 .2-.1.3 0 .2-.2.4-.1.6 0 .1.2.2.4 0 .6l-.3.2h-.4c-.2 0-.3-.2-.4-.2l.2.1Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#585858",
            d: "M33.5 28.4c2.2-2.9 5.1-4.6 8.8-5.1 3.6-.5 6.9.3 9.8 2.6 2.9 2.2 4.6 5.1 5.1 8.8.5 3.6-.3 6.9-2.6 9.8-2.2 2.9-5.1 4.6-8.8 5.1-3.6.5-6.9-.3-9.8-2.6-2.8-2.2-4.5-5.1-5-8.8-.5-3.6.3-6.9 2.4-9.8M85.8 7.2 69.9 9.4l1.1 7.9 15.9-2.2-1.1-7.9ZM17.554 13.295 6.758 14.793l.687 4.953 10.797-1.499-.688-4.952Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#2F2F2F",
            d: "M42.3 23.2c-3.6.5-6.6 2.2-8.8 5.1-2.1 2.9-2.9 6.2-2.4 9.8.5 3.6 2.2 6.6 5 8.8 2.9 2.2 6.2 3.1 9.8 2.6 3.6-.5 6.6-2.2 8.8-5.1 2.2-2.9 3.1-6.2 2.6-9.8-.5-3.6-2.2-6.6-5.1-8.8-2.9-2.2-6.2-3.1-9.8-2.6"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M49.5 27.1c-.5-.2-.9-.3-1.3-.3s-.6.3-.8.6c-.1.3 0 .7.2 1.1.2.4.6.7 1.1.9.5.2.9.3 1.3.3s.7-.3.8-.6c.1-.3 0-.7-.2-1.1-.2-.4-.6-.7-1.1-.9Z"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#BDBDBD", d: "m8.5 8.7.4 2.7 10.8-1.5-.4-2.7L8.5 8.7Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#5B374A",
            d: "M99.4 44.1c-.8-6-1.7-12-2.5-17.9-.4-3.1-.9-6.1-1.3-9.2-.4-3-.8-5.9-1.2-8.9-.1-.8-.2-1.7-.4-2.5-.3-1.6-1.1-3.2-2.3-4.2-2.4-2.2-6-1.2-8.9-.8-4.6.6-9.2 1.3-13.8 1.9-6.2.9-12.4 1.7-18.6 2.6-6 .8-11.9 1.7-17.9 2.5-3.8.5-7.7 1.1-11.5 1.6h-.9c0-.6-.2-1.3-.3-2 0-.3-.5-.6-.8-.5-3.2.4-6.3.9-9.5 1.3-.5 0-.9.1-1.4.2-.2 0-.3.3-.3.5.1.8.2 1.5.3 2.3-2.7.3-5.9.4-7.4 3-1.3 2.2-.8 4.9-.5 7.3.6 4.1 1.1 8.2 1.7 12.3.7 5 1.4 9.9 2.1 14.9.6 4.5 1.2 8.9 1.9 13.4.5 3.2 2.3 6.2 5.8 6.4 1 0 1.9-.1 2.9-.3 1-.1 1.9-.3 2.9-.4 4.9-.7 9.9-1.4 14.8-2.1 2.9-.4 5.9-.8 8.8-1.2 6.1-.9 12.2-1.7 18.4-2.6 4.6-.6 9.2-1.3 13.8-1.9 3.1-.4 6.1-.9 9.2-1.3 3-.4 6-.8 9-1.3 1.8-.2 3.7-.3 5.4-1.1 4.6-2.2 2.9-8.2 2.4-12.1l.1.1ZM97.1 35c.6 4.5 1.3 9 1.9 13.5-3 .4-6 .8-9 1.3-4.9.7-9.9 1.4-14.8 2.1-1.1.2-2.3.3-3.4.5-5.2.7-10.4 1.5-15.6 2.2 5-3.3 8.6-8.8 9.4-14.8.3-2 .3-4 0-6-.5-3.2-1.5-6.3-3.3-9.1 3.7-.5 7.3-1 11-1.5 6.1-.9 12.2-1.7 18.3-2.6 1.2-.2 2.3-.3 3.5-.5.7 4.9 1.4 9.9 2.1 14.8l-.1.1ZM40.8 56.9h-.4c-5.8-1-11.1-4.7-14.1-9.7-2.9-5-3.6-11.2-1.9-16.7 1.8-5.6 6-10.5 11.4-12.8 5.4-2.3 11.8-2.4 17.1.1 3.2 1.6 6 3.9 8.2 6.9 1.9 2.8 3 5.9 3.4 9.2.5 4.3-.2 8.6-2.3 12.4-2.1 3.8-5.3 6.9-9.2 8.8-2.5 1.1-5.2 1.8-7.9 2-1.4 0-2.8 0-4.1-.1l-.2-.1Zm-22.6-49h.7c0 .6.2 1.1.2 1.7-3.1.4-6.1.9-9.2 1.3h-.6c0-.6-.2-1.1-.2-1.7 3-.4 6.1-.8 9.1-1.3ZM1.8 14.8c1.4-2.5 4.8-2.5 7.3-2.8 3.2-.4 6.3-.9 9.5-1.3.4 0 .9-.1 1.3-.2 2.1-.3 4.2-.6 6.2-.9 5-.7 10.1-1.4 15.1-2.1 6.2-.9 12.4-1.7 18.6-2.6 5.6-.8 11.2-1.6 16.9-2.4 3.2-.4 6.4-.9 9.6-1.3 1.6-.2 3.2-.3 4.5.7 2 1.5 2.1 4.2 2.4 6.4l1.5 10.8c-3.7.5-7.5 1-11.2 1.6-6.1.9-12.2 1.7-18.3 2.6-1.3.2-2.5.4-3.8.5-3.8-5.1-9.8-8.6-16.2-9-6-.3-12 1.7-16.3 5.8-2.6 2.5-4.6 5.6-5.7 9-2.3.3-4.6.6-7 1-3.8.5-7.6 1.1-11.4 1.6l-2 .3c0-.6-.2-1.3-.3-1.9-.4-2.9-.8-5.9-1.2-8.8-.3-2.3-.9-4.9.3-7h.2ZM4 39.5c-.3-2-.6-4-.8-6 2.3-.3 4.6-.6 6.8-1 3.8-.5 7.6-1.1 11.4-1.6.5 0 1.1-.1 1.6-.2-1.5 5.5-.6 11.6 2.3 16.5 2.8 4.6 7.3 8.2 12.4 9.8-1.8.3-3.6.5-5.5.8-.8.1-1.7.2-2.5.4-2.6.4-5.3.7-7.9 1.1L9.2 61.1c-.7.1-1.5.2-2.2.3l-.6-4.2c-.8-5.9-1.6-11.8-2.5-17.7H4Zm91.9 15.9c-1.6.6-3.5.7-5.2.9l-16 2.2c-2.4.3-4.7.7-7.1 1-5.8.8-11.7 1.6-17.5 2.4-5.1.7-10.3 1.4-15.4 2.2-2.5.3-5 .7-7.5 1-3 .4-6 .8-9 1.3-1.8.2-3.5.6-5.3.8-1.7.2-3.4-.2-4.4-1.7-.7-.9-1-2-1.2-3.1 2.5-.4 5-.7 7.6-1.1l12.6-1.8c1-.1 1.9-.3 2.9-.4l6.3-.9c1.2-.2 2.3-.3 3.5-.5h.7c1.4.1 2.8.3 4.2.2 3-.1 5.9-.8 8.6-2.1 5.4-.8 10.9-1.5 16.3-2.3l2.3-.3c3.1-.4 6.2-.9 9.4-1.3 4.9-.7 9.9-1.4 14.8-2.1.9-.1 1.8-.2 2.7-.4.1 2.4-.7 4.9-3.2 5.8l-.1.2Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#5B374A",
            d: "M6.2 14.8c.2 1.6.5 3.3.7 4.9 0 .3.5.6.8.5 3.1-.4 6.3-.9 9.4-1.3.4 0 .9-.1 1.3-.2.2 0 .3-.3.3-.5-.2-1.6-.5-3.3-.7-4.9 0-.3-.5-.6-.8-.5-3.1.4-6.3.9-9.4 1.3-.4 0-.9.1-1.3.2-.3 0-.3.2-.3.4v.1Zm10.3-.8h.6c.2 1.3.4 2.6.5 3.9-3 .4-6.1.8-9.1 1.3h-.6l-.5-3.9c3-.4 6.1-.8 9.1-1.3ZM55.699 43.9c1.8-2.8 2.5-6 2-9.3-.8-5.6-5.1-10.4-10.7-11.7-5.6-1.3-11.6 1.1-14.6 6-3 4.8-2.7 11.4.8 15.9 3.6 4.7 9.8 6.5 15.3 4.7 3-1 5.5-3 7.2-5.6Zm-5.9 3.9c-4.8 2.4-10.7 1.6-14.6-2.1-3.7-3.6-4.8-9.6-2.7-14.3 2.2-5 7.2-8 12.6-7.7 3 .1 5.8 1.5 7.9 3.5 2.1 2 3.3 4.6 3.7 7.4.7 5.3-2 10.8-6.9 13.2ZM69.299 9.4c.4 2.6.7 5.3 1.1 7.9 0 .3.5.6.8.5 4.6-.6 9.3-1.3 13.9-1.9.7 0 1.3-.2 2-.3.2 0 .3-.3.3-.5l-1.1-7.9c0-.3-.5-.6-.8-.5-4.6.6-9.3 1.3-13.9 1.9-.7 0-1.3.2-2 .3-.3 0-.3.2-.3.4v.1Zm14.7-1.4c.4 0 .9-.1 1.3-.2.3 2.3.6 4.5 1 6.8-4.5.6-9.1 1.3-13.6 1.9-.4 0-.9.1-1.3.2-.3-2.3-.6-4.5-1-6.8 4.5-.6 9.1-1.3 13.6-1.9Z"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "camera-classic-clip", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "m2.147 0 100.15 3.15-2.146 68.265L0 68.266z" }) }) })
    ]
  }
);
export {
  CameraClassicIcon
};
